import EcsContact from './EcsContact';
import { CONTACT_TYPE } from '@/constants/contactConstants';

export default class EcsCrmContact extends EcsContact {
  get contactType() {
    return CONTACT_TYPE.crm;
  }

  get isCrmContact() {
    return true;
  }

  get isInternalContact() {
    return false;
  }

  get name() {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim() || this.email || this.phone1;
  }

  get phones() {
    const phones = [];

    if (!this.phone1) {
      return phones;
    }

    Object.entries(this).forEach(([key, value]) => {
      if (key.toLowerCase().includes('phone')) {
        value && phones.push({ description: 'Phone', value });
      }
    });

    return phones;
  }

  get endPoint() {
    return this.phones.length ? this.phones[0].value : null;
  }

  get isSMSEnabled() {
    return this.phones.length + this.mobiles.length > 0;
  }
}
